import Alpine from 'alpinejs';
import api, { money, requireAuth } from './api.js';

function createInkoCreationPrintOrder() {
  return {
    projectId: '',
    loading: true,
    busy: false,
    catalog: null,
    quote: null,
    finishKey: 'none',
    deliveryType: 'pickup',
    paymentMethod: 'wallet',
    order: null,

    init() {
      this.projectId = this.$el.dataset.projectId || '';
      if (!requireAuth() || !this.projectId) return;
      this.load();
    },

    async load() {
      this.loading = true;
      try {
        this.catalog = await api.printCatalog();
        await this.refreshQuote();
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal memuat katalog cetak.', 'error');
      } finally {
        this.loading = false;
      }
    },

    async refreshQuote() {
      try {
        this.quote = await api.printQuote(this.projectId, {
          finish_key: this.finishKey,
          delivery_type: this.deliveryType,
          quantity: 1,
        });
      } catch {
        this.quote = null;
      }
    },

    async onFinishChange() {
      await this.refreshQuote();
    },

    async createOrder() {
      this.busy = true;
      try {
        this.order = await api.createPrintOrder(this.projectId, {
          finish_key: this.finishKey,
          delivery_type: this.deliveryType,
          quantity: 1,
        });
        window.toast?.(`Order ${this.order.order_number} dibuat.`, 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal membuat order.', 'error');
      } finally {
        this.busy = false;
      }
    },

    async payOrder() {
      if (!this.order) return;
      this.busy = true;
      try {
        const result = await api.payPrintOrder(this.order.id, this.paymentMethod);
        this.order = result.order;
        window.toast?.(
          result.status === 'paid' ? 'Pembayaran berhasil.' : 'Menunggu pembayaran.',
          result.status === 'paid' ? 'success' : 'info',
        );
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Pembayaran gagal.', 'error');
      } finally {
        this.busy = false;
      }
    },

    money,
  };
}

Alpine.data('inkoCreationPrintOrder', createInkoCreationPrintOrder);
